import {
	PROVINCE_FETCH,
	PROVINCE_FETCH_SUCCESS,
	PROVINCE_FETCH_FAIL,

	SUB_PROVINCE_FETCH,
	SUB_PROVINCE_FETCH_SUCCESS,
	SUB_PROVINCE_FETCH_FAIL,

	DISTRICT_FETCH,
	DISTRICT_FETCH_SUCCESS,
	DISTRICT_FETCH_FAIL,


} from '../actions';

export const provinceFetch = (province) => ({
	type: PROVINCE_FETCH,
	payload: { province }
});

export const provinceSuccess = (province) => ({
	type: PROVINCE_FETCH_SUCCESS,
	payload: province
});

export const provinceFail = (message) => ({
	type: PROVINCE_FETCH_FAIL,
	payload: { message }
});


export const subprovinceFetch = (subprovince, history, desiredPath) => ({
	type: SUB_PROVINCE_FETCH,
	payload: { subprovince, history, desiredPath }
});

export const subprovinceSuccess = (subprovince) => ({
	type: SUB_PROVINCE_FETCH_SUCCESS,
	payload: subprovince
});

export const subprovinceFail = (message) => ({
	type: SUB_PROVINCE_FETCH_FAIL,
	payload: { message }
});

export const districtFetch = (district, history, desiredPath) => ({
	type: DISTRICT_FETCH,
	payload: { district, history, desiredPath }
});

export const districtSuccess = (district) => ({
	type: DISTRICT_FETCH_SUCCESS,
	payload: district
});

export const districtFail = (message) => ({
	type: DISTRICT_FETCH_FAIL,
	payload: { message }
});
